// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".coordenacao .professor-image-pos{width:calc(98px + 3vw);height:calc(96px + 3vw)}.coordenacao .border-prof-img{width:calc(100px + 3vw);height:calc(100px + 3vw)}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
